import { Block } from "@mui/icons-material";
import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
        }}
      >
        <Block sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
        <Typography
          variant="h1"
          sx={{ fontSize: "4rem", fontWeight: "bold", mb: 2 }}
        >
          403
        </Typography>
        <Typography variant="h5" gutterBottom>
          Доступ запрещен
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          У вас недостаточно прав для просмотра этой страницы.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/dashboard")}
        >
          Вернуться на главную
        </Button>
      </Box>
    </Container>
  );
};
